export type Role = "player" | "author" | "reviewer" | "tenant_admin";

export interface SessionUser {
  id: number;
  email: string;
  display_name: string;
  public_name: string;
  roles: Role[];
  has_password_login: boolean;
  opt_out_leaderboard: boolean;
  pseudonym: string;
  locale: string;
  date_joined: string;
}

export interface Session {
  authenticated: boolean;
  user: SessionUser | null;
  sso_provider_id: string;
}

export function hasRole(user: SessionUser | null | undefined, ...roles: Role[]): boolean {
  if (!user) return false;
  return roles.some((r) => user.roles.includes(r));
}
